import React, {useState} from 'react'
import {useParams} from 'react-router-dom'

import Style from './style'
import MainHeader from 'widget/MainHeader'
import CountdownTimer from 'shared/ui/CountdownTimer'
import useSupabaseRealtime from 'entity/event/useSupabaseRealtime'
import useGetEventDetail from 'entity/event/useGetEventDetail'

const TimerDemo = () => {
	const {idx} = useParams()
	const [infoData, setInfoData] = useState([])

	// Get event data
	const [eventData] = useGetEventDetail()

	// Use the countdown timer logic
	const {
		timeData,
		countDown,
		elapsedTime,
		nextBreak,
		regClose,
		elapsedTimeDisplay,
		isLoading,
	} = useSupabaseRealtime(true, setInfoData, eventData)

	const btnList = [
		{
			label: 'Back to Event',
			clickEvent: () => window.history.back(),
		},
	]

	if (isLoading) {
		return (
			<Style.Wrapper>
				<MainHeader btnList={btnList}>Tournament Timer Demo</MainHeader>
				<Style.LoadingWrapper>
					<div>Loading timer data...</div>
				</Style.LoadingWrapper>
			</Style.Wrapper>
		)
	}

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList}>
				Tournament Timer Demo - Event {idx}
			</MainHeader>

			<Style.ContentDiv>
				<Style.Section>
					<h2>Tournament Timer</h2>
					<CountdownTimer
						countDown={countDown}
						elapsedTime={elapsedTimeDisplay}
						nextBreak={nextBreak}
						regClose={regClose}
						level={timeData?.level}
						timeData={timeData}
					/>
				</Style.Section>

				<Style.Section>
					<h2>Compact Timer View</h2>
					<CountdownTimer
						countDown={countDown}
						level={timeData?.level}
						compact={true}
					/>
				</Style.Section>

				<Style.Section>
					<h2>Game Information</h2>
					<Style.InfoGrid>
						{infoData.map((info, index) => (
							<Style.InfoItem key={index}>
								<Style.InfoLabel>{info.label}</Style.InfoLabel>
								<Style.InfoValue>{info.data}</Style.InfoValue>
							</Style.InfoItem>
						))}
					</Style.InfoGrid>
				</Style.Section>

				<Style.Section>
					<h2>Raw Timer Data</h2>
					<Style.DataDisplay>
						<pre>
							{JSON.stringify(
								{
									countDown,
									elapsedTime,
									elapsedTimeDisplay,
									nextBreak,
									regClose,
									timeData: {
										level: timeData?.level,
										sb: timeData?.sb,
										bb: timeData?.bb,
										ante: timeData?.ante,
										next_level: timeData?.next_level,
										next_sb: timeData?.next_sb,
										next_bb: timeData?.next_bb,
										next_ante: timeData?.next_ante,
										rest_player: timeData?.rest_player,
										total_player: timeData?.total_player,
										pause: timeData?.pause,
										event_state: timeData?.event_state,
									},
								},
								null,
								2
							)}
						</pre>
					</Style.DataDisplay>
				</Style.Section>

				<Style.TestSection>
					<h2>Game Logic Test</h2>
					<Style.TestButton
						onClick={() => {
							if (window.testBreakTimeCalculation) {
								window.testBreakTimeCalculation()
								alert('Check browser console for test results!')
							} else {
								import('shared/lib/gameLogic').then((module) => {
									module.testBreakTimeCalculation()
									alert('Check browser console for test results!')
								})
							}
						}}
					>
						Run Break Time Calculation Test
					</Style.TestButton>
				</Style.TestSection>
			</Style.ContentDiv>
		</Style.Wrapper>
	)
}

export default TimerDemo
